import en from './en.json'
import sp from './sp.json'
export const languages = {
  en: en,
  sp: sp,
}